import { css } from 'lit';

export const collapsibleOptionsStyles = css`
  span.checkmark {
    background-color: var(
      --fg-message-success,
      var(--fg-fallback-message-success)
    );
    border: 2px solid white;
    border-radius: 50%;
    color: white;
    display: none;
    height: 24px;
    left: -6px;
    place-content: center;
    position: absolute;
    text-align: center;
    top: -10px;
    width: 24px;
  }

  span.checkmark svg {
    height: 100%;
    max-width: 13px;
    max-height: 13px;
    width: 100%;
  }

  span.checkmark.selected {
    display: grid;
    z-index: 10;
  }
`;
